"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importStar(require("react"));
const modalInformation_1 = __importDefault(require("../../utils/data/modalInformation"));
const defaultLabels_1 = require("../../utils/data/defaultLabels");
const CardsContext_1 = __importDefault(require("../../context/CardsContext"));
const tab_click_1 = require("../../utils/clickstream/tab-click");
const modalMainInfo = {
    '10-Year Fixed Rate Conventional': modalInformation_1.default.conventionalDescription,
    '15-Year Fixed Rate Conventional': modalInformation_1.default.conventionalDescription,
    '20-Year Fixed Rate Conventional': modalInformation_1.default.conventionalDescription,
    '20-Year Fixed Rate FHA': modalInformation_1.default.fhaDescription,
    '25-Year Fixed Rate FHA': modalInformation_1.default.fhaDescription,
    '30-Year Fixed Rate Conventional': modalInformation_1.default.conventionalDescription,
    '30-Year Fixed Rate FHA': modalInformation_1.default.fhaDescription,
    '30-Year Jumbo': modalInformation_1.default.jumboDescription,
    '30-Year VA': modalInformation_1.default.conventionalDescription,
    '7/6 Adjustable Rate Mortgage': modalInformation_1.default.adjustableRateDescription,
};
const RateModal = ({ apr, date, modalTitle, pointsPaid, monthlyPayment, rate, }) => {
    const { whiteCardModalButtonText, whiteCardsButtonText, whiteCardButtonLink, } = (0, react_1.useContext)(CardsContext_1.default);
    const btnLabel = whiteCardModalButtonText || defaultLabels_1.whiteCardPlaceholders.modalOpener;
    const principal = modalTitle.match('Jumbo') ? 950000 : 275000;
    const onHoverHandler = (element) => {
        (0, tab_click_1.triggerHoverCardElementEvent)(`rate-card-modal-hover-${modalTitle}`, element, btnLabel);
    };
    const onClickHandler = () => {
        (0, tab_click_1.triggerOpenModalEvent)(`rate-card-modal-open-${modalTitle}`, btnLabel);
    };
    const MainInfo = () => {
        const description = modalMainInfo[modalTitle];
        const modalDescription = description
            .replace('_principal_', principal.toLocaleString())
            .replace('_rate_', rate)
            .replace('_apr_', apr)
            .replace('_amount_', monthlyPayment)
            .replace('_points_', pointsPaid);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            modalTitle.match('FHA') && (react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" }, modalInformation_1.default.fhaInformation)),
            react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" }, modalDescription)));
    };
    const Summary = () => (react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" }, modalInformation_1.default.summary.replace('_date_', new Date(date).toLocaleDateString())));
    const ModalBody = () => (react_1.default.createElement(constellation_1.Box, { sx: {
            margin: '$spacing.xl',
        } },
        react_1.default.createElement(constellation_1.Heading, { level: "3", fontcolor: "black", marginBottom: "lg" }, "Sample loan terms"),
        react_1.default.createElement(Summary, null),
        react_1.default.createElement(constellation_1.Heading, { level: "5" },
            modalTitle,
            " Loan Example"),
        react_1.default.createElement(MainInfo, null),
        react_1.default.createElement(constellation_1.Heading, { level: "5" }, "For all rates shown, unless otherwise noted, we assumed:"),
        react_1.default.createElement(constellation_1.List, null, modalInformation_1.default.assumptions.map((text) => (react_1.default.createElement(constellation_1.List.Item, { paddingY: "none" }, text))))));
    return (react_1.default.createElement(constellation_1.Trigger, { triggered: ({ isOpen, onClose }, close) => {
            const modalClickHandler = () => {
                if (whiteCardButtonLink) {
                    window.location.href = whiteCardButtonLink;
                }
                close();
            };
            const modalCloseHandler = () => {
                (0, tab_click_1.triggerCloseModalEvent)();
                onClose();
            };
            return (react_1.default.createElement(constellation_1.ModalDialog, { size: "lg", isOpen: isOpen, onClose: modalCloseHandler, scrollDocument: true, dividers: false, renderBody: ModalBody, renderFooter: react_1.default.createElement(constellation_1.ButtonGroup, { "aria-label": "Modal actions" },
                    react_1.default.createElement(constellation_1.Button, { buttonType: "primary", onClick: modalClickHandler }, whiteCardsButtonText ||
                        defaultLabels_1.whiteCardPlaceholders.buttonText)) }));
        } },
        react_1.default.createElement(constellation_1.TextButton, { buttonType: "tertiary", onMouseEnter: () => onHoverHandler('button'), onClick: () => onClickHandler() }, btnLabel)));
};
exports.default = RateModal;
